import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import { getCommunityCheck } from 'apis/CommunityAPI';
import Input from 'components/lib/Input';
import { COMMUNITY_AGGREGATOR_FIELDS } from 'constants/community';

const StyledError = styled.div`
  display: flex;
  gap: 2px;
  .info {
    color: var(--negative-orange);
  }
  font-size: 12px;
`;

const BasicInfoEditFormAggregators = () => {
  const validateOnField = (communityId: number, field: string) => {
    return async (_: any, value: any) => {
      if (!value) return Promise.resolve(); // skip validation if empty

      const response = await getCommunityCheck({ [field]: value });

      const filteredResponse = (response ?? []).filter((community: any) => community.id !== communityId);
      const duplicateCommunity = filteredResponse.length > 0 ? filteredResponse[0] : null;

      return duplicateCommunity
        ? Promise.reject(
            <StyledError>
              <span className={'info'}>Duplicate community detected</span>
              <span>·</span>
              <a href={`/communities/${duplicateCommunity.id}/info`} target="_blank" rel="noopener noreferrer">
                View Community
              </a>
            </StyledError>
          )
        : Promise.resolve();
    };
  };

  return (
    <>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const communityId = getFieldValue('community_id');

          return (
            <>
              <Form.Item
                name="google_map_location"
                label="Google Place ID"
                rules={[
                  {
                    validator: validateOnField(communityId, COMMUNITY_AGGREGATOR_FIELDS.GOOGLE),
                  },
                ]}
              >
                <Input style={{ height: 36 }} placeholder={'Enter Google Place ID (optional)'} />
              </Form.Item>
              <Form.Item
                name="a_place_for_mom_id"
                label="A Place For Mom ID"
                rules={[
                  {
                    validator: validateOnField(communityId, COMMUNITY_AGGREGATOR_FIELDS.APFM),
                  },
                ]}
              >
                <Input style={{ height: 36 }} placeholder={'Enter APFM ID (optional)'} />
              </Form.Item>
              <Form.Item
                name="caring_url"
                label="Caring URL"
                rules={[
                  {
                    validator: validateOnField(communityId, COMMUNITY_AGGREGATOR_FIELDS.CARING),
                  },
                ]}
              >
                <Input style={{ height: 36 }} placeholder={'Enter Caring URL (optional)'} />
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
    </>
  );
};

export default BasicInfoEditFormAggregators;
